import React from 'react';
import './Signup.css';

function Signup() {
  return (
    <div className='signup'>Welcome to Amazon Sign up page,
    Enter your email address and password to login to your dashboard.
    </div>
  )
}

export default Signup